import React, { useState } from 'react';

const FAQAccordion = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      {faqs.map((faq, index) => (
        <div 
          key={index} 
          className={`accordion ${activeIndex === index ? 'active' : ''}`}
        >
          <div 
            className="accordion-header"
            onClick={() => toggleAccordion(index)}
          >
            <h4>{faq.question}</h4>
            <span className="accordion-icon">▼</span>
          </div>
          <div className="accordion-content">
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQAccordion;
